import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" updated="June 22, 2026">
      <h2>1. What are cookies?</h2>
      <p>Cookies are small text files stored on your device when you visit a website or use a web application. They allow websites to remember your preferences, keep you signed in, and understand how you use the service.</p>
      <p>We also use similar technologies such as web beacons, pixel tags, and local storage. All references to "cookies" in this policy include these technologies.</p>

      <h2>2. Cookie categories we use</h2>
      <h3>Strictly necessary</h3>
      <p>These cookies are essential for the Service to function. They cannot be disabled.</p>
      <ul>
        <li>Maintaining your login session</li>
        <li>Storing your authentication token securely</li>
        <li>Enabling secure payment processing</li>
        <li>Protecting against cross-site request forgery (CSRF)</li>
      </ul>
      <h3>Functional</h3>
      <p>These cookies remember your preferences to improve your experience.</p>
      <ul>
        <li>Saved workspace settings and UI preferences</li>
        <li>Language and timezone settings</li>
        <li>Recent activity and shortcuts</li>
      </ul>
      <h3>Analytics</h3>
      <p>These cookies help us understand how users interact with the Service so we can improve it. Data is aggregated and does not directly identify you.</p>
      <ul>
        <li>Pages and features visited</li>
        <li>Session duration and drop-off points</li>
        <li>Error rates and performance metrics</li>
      </ul>
      <h3>Marketing</h3>
      <p>We may use marketing cookies to measure campaign effectiveness and show relevant content. These cookies may track you across other websites. We use these only where permitted by applicable law.</p>

      <h2>3. Third-party cookies</h2>
      <table>
        <thead><tr><th>Provider</th><th>Purpose</th><th>More info</th></tr></thead>
        <tbody>
          <tr><td>Google Analytics</td><td>Usage analytics</td><td><a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">policies.google.com/privacy</a></td></tr>
          <tr><td>Stripe</td><td>Payment processing</td><td><a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">stripe.com/privacy</a></td></tr>
          <tr><td>Intercom (or similar)</td><td>In-app support chat</td><td>Provider's privacy policy</td></tr>
        </tbody>
      </table>
      <p>We do not control third-party cookies. Please review each provider's policy for details.</p>

      <h2>4. Cookie retention</h2>
      <table>
        <thead><tr><th>Category</th><th>Typical retention</th></tr></thead>
        <tbody>
          <tr><td>Strictly necessary</td><td>Session or up to 1 year</td></tr>
          <tr><td>Functional</td><td>Up to 1 year</td></tr>
          <tr><td>Analytics</td><td>Up to 2 years</td></tr>
          <tr><td>Marketing</td><td>Up to 90 days</td></tr>
        </tbody>
      </table>

      <h2>5. Managing cookies</h2>
      <h3>Browser settings</h3>
      <p>You can control or delete cookies via your browser settings:</p>
      <ul>
        <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
        <li><strong>Firefox:</strong> Options → Privacy &amp; Security → Cookies and Site Data</li>
        <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
        <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
      </ul>
      <p>Blocking all cookies may prevent some parts of the Service from working correctly.</p>
      <h3>Opt out of analytics</h3>
      <p>To opt out of Google Analytics, install the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">Google Analytics opt-out browser add-on</a>.</p>
      <h3>Do Not Track</h3>
      <p>Some browsers send a "Do Not Track" (DNT) signal. The Service does not currently respond to DNT signals as there is no consistent industry standard.</p>

      <h2>6. Changes to this policy</h2>
      <p>We may update this Cookie Policy from time to time. Changes will be posted here with an updated effective date. Continued use of the Service after changes constitutes acceptance.</p>

      <h2>7. Contact</h2>
      <p>Questions about our cookie practices? Email <a href="mailto:support@ordrs.ai">support@ordrs.ai</a>. See also our <Link to="/privacy">Privacy Policy</Link>.</p>
    </LegalLayout>
  );
}
